import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { reducer } from './reducer';
import { EffectsModule } from '@ngrx/effects';
import { AllowedVehicleStoreEffects } from './effects';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        StoreModule.forFeature('allowedVehicle', reducer),
        EffectsModule.forFeature([AllowedVehicleStoreEffects])
    ],
    providers: []
})
export class AllowedVehicleStoreModule {}
